import moment from 'moment'

import sendNotification from './send_notification'

const preparePayloadForNotification = (user, otherUser, sessionLength, startTime, sessionId) => {
  return {
    sessionId,
    sessionLength,
    startTime,
    role: user.get('role'),
    user: {
      name: user.get('name'),
      uid: user.get('uid'),
      email: user.get('email')
    },
    otherUser: {
      name: otherUser.get('name'),
      uid: otherUser.get('uid'),
      email: otherUser.get('email')
    }
  }
}

const sendScheduleConfirmationNotification = (user, otherUser, sessionLength, startTime, sessionId) => {
  const title = 'Your Session Confirmation'
  const body = 'Your paid session is booked.'
  const sent = false
  const from = otherUser.get('uid')
  const to = user.get('uid')
  const payload = preparePayloadForNotification(user, otherUser, sessionLength, startTime, sessionId)

  return sendNotification('sessionConfirmation', {
    title, body, sent, from, to, payload, refKey: sessionId
  })
}

const sendScheduleReminderNotification = (user, otherUser, sessionLength, startTime, dueTime, sessionId) => {
  const title = 'Reminder for Your Session'
  const body = 'Your session is upcoming.'
  const sent = false
  const enqueued = false
  const from = otherUser.get('uid')
  const to = user.get('uid')
  const payload = preparePayloadForNotification(user, otherUser, sessionLength, startTime, sessionId)

  return sendNotification('scheduleReminder', {
    title, body, sent, enqueued, dueTime, from, to, payload, refKey: sessionId
  })
}

const sendScheduleReminderNotifications = (user, otherUser, sessionLength, startTime, sessionId) => {
  const dayBefore = moment(startTime).subtract(1, 'day').valueOf()
  const hourBefore = moment(startTime).subtract(1, 'hour').valueOf()

  if (moment().isSameOrBefore(moment(dayBefore))) {
    return sendScheduleReminderNotification(user, otherUser, sessionLength, startTime, dayBefore, sessionId)
      .then(sendScheduleReminderNotification.bind(null, user, otherUser, sessionLength, startTime, hourBefore, sessionId))
  }
  else {
    return sendScheduleReminderNotification(user, otherUser, sessionLength, startTime, hourBefore, sessionId)
  }
}


const saveScheduleNotification = (user, otherUser, sessionLength, startTime, sessionId) => {
  return sendScheduleConfirmationNotification(user, otherUser, sessionLength, startTime, sessionId)
    .then(sendScheduleReminderNotifications.bind(null, user, otherUser, sessionLength, startTime, sessionId))
}

export default (expert, user, sessionLength, startTime, sessionId) => {
 return saveScheduleNotification(expert, user, sessionLength, startTime, sessionId)
  .then(saveScheduleNotification.bind(null, user, expert, sessionLength, startTime, sessionId))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/save_schedule_notifications.js
 **/